export default __webpack_public_path__ + "static/media/7.164c60dc.png";